import { ActivityFeed } from "@/components/ui";
import { useChecklistItemActivities } from "@/hooks/use-checklist-item-activities";
import type { ChecklistItemId } from "@/packages/types";
import { useTranslation } from "@/packages/utils";

interface ActivityContentProps {
  checklistItemId: ChecklistItemId;
}

export function ActivityContent({ checklistItemId }: ActivityContentProps) {
  const { activities, isLoading } = useChecklistItemActivities(checklistItemId);
  const { t } = useTranslation("audits");

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="flex flex-col items-center gap-3">
          <div className="w-7 h-7 rounded-full border-2 border-accent border-t-transparent animate-spin" />
          <p className="text-xs text-muted">{t("detail.activity.loading")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-0">
      <ActivityFeed
        items={activities}
        emptyTitle={t("detail.activity.emptyTitle")}
        emptyDescription={t("detail.activity.checklistEmptyDescription")}
      />
    </div>
  );
}
